// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorConfirmation_errorMessage__OaBK+"};